export class PropertyViewModelPropertyChangedEventArgs {
    propertyName: string;
    value: any;
}
